import { SpinTickerItem } from "./FortuneWheel";

import { RewardCategory } from "@/types";

// Helper function to generate random spins
export const generateFakeDataSpin = (): SpinTickerItem => {
  // Random wallet address
  const randomAddress = `0x${Array.from({ length: 40 }, () => Math.floor(Math.random() * 16).toString(16)).join("")}`;

  // Fixed odds: 25% chance for each of these four categories
  const categoryOptions = [
    RewardCategory.PP,
    RewardCategory.RaffleTicket,
    RewardCategory.PlumeToken,
    RewardCategory.Nothing,
  ];
  let randomCategory = categoryOptions[Math.floor(Math.random() * 4)];

  // Random reward amount based on category
  let amount = 0;
  switch (randomCategory) {
    case RewardCategory.PlumeToken:
      amount = Math.round(Math.random()) + 1; // 1 or 2
      break;
    case RewardCategory.PP:
      amount = 100; // 100
      break;
    case RewardCategory.RaffleTicket:
      amount = (Math.floor(Math.random() * 7) + 1) * 8; // 8-56
      break;
    case RewardCategory.Nothing:
      amount = 0;
      break;
    default:
      randomCategory = RewardCategory.Nothing;
      amount = 0;
  }

  return {
    walletAddress: randomAddress,
    rewardCategory: randomCategory.toString(),
    rewardAmount: amount,
    timestamp: Date.now(),
    id: `fake-${randomAddress.substring(0, 6)}-${Date.now()}`,
  };
};
